import { render, staticRenderFns } from "./dxOrderDetail.vue?vue&type=template&id=40b27fa8&scoped=true&"
import script from "./dxOrderDetail.vue?vue&type=script&lang=js&"
export * from "./dxOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./dxOrderDetail.vue?vue&type=style&index=0&id=40b27fa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b27fa8",
  null
  
)

export default component.exports